module.exports = __webpack_public_path__ + "static/media/muji ui2.5e519ad7.png";